import fb from '@/firebaseConfig';
import helpers from './helpers';
import firebase from 'firebase';
import { increment } from 'vuex-easy-firestore';
import get from 'lodash/get';
////////////////////// functions ///////////////////////
const isSequetial = function(tempArray) {
  tempArray.sort(function(a, b) {
    return a - b;
  });
  for (let i = 0; i < tempArray.length - 1; i++) {
    if (tempArray[i + 1] - tempArray[i] !== 1) {
      return false;
    }
  }
  return true;
};

const contextModule = {
  //  Easy VUEX firestore configuration
  firestorePath: 'contexts',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'context',
  statePropName: 'contextData',
  namespaced: true, // automatically added
  sync: {
    patchHook: function(updateStore, doc) {
      console.log('patch hook context', doc);
      // const updateDoc = {
      //   created: new Date(),
      //   sync: 'localChange',
      //   collection: 'contexts',
      //   doc
      // };
      // fb.troubleshootingLogsCollection.add(updateDoc);
      updateStore(doc);
    },

    patchHookBeforeSync: function(updateFirestore, doc, store) {
      console.log('patch hook before context', doc);
      // const updateDoc = {
      //   created: new Date(),
      //   sync: 'beforeSync',
      //   collection: 'contexts',
      //   doc
      // };
      // fb.troubleshootingLogsCollection.add(updateDoc);
      updateFirestore(doc);
    }
  },
  serverChange: {
    modifiedHook: function(updateStore, doc) {
      console.log('server change context', doc);
      // const updateDoc = {
      //   created: new Date(),
      //   sync: 'serverChange',
      //   collection: 'contexts',
      //   doc
      // };
      // fb.troubleshootingLogsCollection.add(updateDoc);
      updateStore(doc);
    }
  },
  state: {
    subscribedId: null
  },
  getters: {
    context: state => {
      if (!state.contextData || !state.subscribedId) {
        return undefined;
      }
      const newState = state.contextData[state.subscribedId];
      return newState;
    },
    // sections: (state, getters) => {
    //   if (!getters.context) {
    //     return [];
    //   }
    //   const sections = getters.context.sections;
    //   return Object.values(sections)
    //     .filter(s => !s.toDelete)
    //     .sort((a, b) => (a.order > b.order ? 1 : -1));
    // },
    // questions: (state, getters) => {
    //   if (!getters.context || !getters.context.questions) {
    //     return [];
    //   }
    //   //function
    //   const filterConditions = function(question) {
    //     if ('id' in question && 'order' in question) {
    //       if (!('toDelete' in question)) {
    //         return true;
    //       }
    //     }
    //     return false;
    //   };
    //   //return a sorted array of questions
    //   const { questions } = getters.context;
    //   const returnObject = Object.values(questions)
    //     .filter(question => filterConditions(question))
    //     .sort((a, b) => a.order - b.order);
    //   return returnObject;
    // },
    userContextPermissions: (state, getters, rootState, rootGetters) => {
      if (!getters.context) {
        return [];
      }
      //return a sorted array of questions
      // const userWorkspace = rootGetters['userWorkspaceLite/currentUserWorkspaceLite'];
      const allUserDocuments = rootState.userWorkspaceLite.allUserDocuments;
      const contextId = getters.context.id;
      if (allUserDocuments && contextId) {
        return get(allUserDocuments, [contextId, 'userPermission'], 'viewing');
      } else {
        return 'viewing';
      }
    },
    userCanEdit: (state, getters) => {
      return getters.userContextPermissions == 'editing';
    },
    userIsWorkspaceMember: (state, getters, rootState) => {
      //  Only workspace members can add new resources to a workspace or access workspace resources
      if (!getters.context) {
        return false;
      }
      const workspaces = rootState.workspaces.workspacesData;
      return !!workspaces[getters.context.workspace];
    }
  },
  mutations: {
    setSubscribedId(state, id) {
      state.subscribedId = id;
    }
  },
  actions: {
    async convertToNewFormat({ dispatch, rootState }, { contextId, pageId }) {
      console.log('convert to new format', contextId, pageId);
      if (!contextId || !pageId) {
        console.log('missing contextId or pageId');
        return false;
      }
      const pages = rootState.pages.pages;
      const sectionPages = Object.values(pages).filter(
        p => !p.toDelete && p.section && p.id != pageId
      );
      const pageNotes = Object.values(pages[pageId].pageNotes).filter(n => !n.toDelete);
      sectionPages.forEach((s, i) => {
        dispatch(
          'pages/addCardNote',
          {
            pageId,
            cardId: false,
            parentNoteId: false,
            html: '',
            widgetInfo: false,
            order: pageNotes.length + i,
            type: 'card',
            pageType: 0,
            embeddedPageId: s.id
          },
          { root: true }
        );
      });
      const contextUpdate = {
        id: contextId,
        basePage: pageId,
        isNewType: true
      };
      console.log(contextUpdate);
      dispatch('patch', contextUpdate);
    },
    async updateContextData({ dispatch }, contextId) {
      console.log('update context data', contextId);
      //  Function to migrate a context to new research card style schema
      let context;
      try {
        const contextSnapshot = await fb.contextsCollection.doc(contextId).get();
        if (contextSnapshot.exists) {
          context = contextSnapshot.data();
        } else {
          console.log('no context');
          return false;
        }
      } catch (e) {
        console.log('could not get context', e);
        throw new Error();
      }
      console.log(context);
      //  get pages
      const pages = {};
      try {
        const pagesSnapshot = await fb.pagesCollection.where('context', '==', contextId).get();
        pagesSnapshot.forEach(doc => {
          const docData = doc.data();
          docData.id = doc.id;
          pages[doc.id] = docData;
        });
      } catch (e) {
        console.log(e);
        return;
      }
      console.log(pages);
      //  Fix context questions first
      const questions = Object.values(context.questions).sort((a, b) => {
        return a.order > b.order ? 1 : -1;
      });
      const nestedQuestions = questions.filter(q => q.type == 1);
      nestedQuestions.forEach((s, i) => {
        //  get all the children and nest under each section
        const nextSection = nestedQuestions[i + 1];
        let pages;
        if (nextSection) {
          pages = questions.filter(q => q.order >= s.order && q.order < nextSection.order);
        } else {
          pages = questions.filter(q => q.order >= s.order);
        }
        s.pages = pages;
      });
      console.log(nestedQuestions);
      const sections = {};

      nestedQuestions.forEach((s, i) => {
        // build the sections part of context
        const sectionPage = pages[s.id];
        //  Add to sections
        sections[s.id] = {
          id: s.id,
          order: i,
          text: s.text,
          description: sectionPage.description || ''
        };

        //  For each child page, update notes and section on that page
        s.pages.forEach((childPage, pageIndex) => {
          const page = pages[childPage.id];
          //  Straight out page notes for each section
          const pageNotesBlocks = Object.values(page.noteBlocks).sort((a, b) => {
            return a.order > b.order ? 1 : -1;
          });
          const noteCards = {};
          const pageNotes = {};
          const questionNotes = pageNotesBlocks.filter(
            n => n.content && n.content.noteType == 'question'
          );
          questionNotes.forEach((card, i) => {
            noteCards[card.id] = {
              title: card.content.html,
              order: i,
              assignedTo: card.content.assignedTo || [],
              createdBy: card.createdBy,
              createdOn: card.createdOn,
              id: card.id,
              state: card.status || null,
              updatedOn: card.updatedOn || new Date(),
              summary: ''
            };
            //  build card notes
            const nextCard = questionNotes[i + 1];
            let notes;
            if (nextCard) {
              notes = pageNotesBlocks.filter(q => q.order > card.order && q.order < nextCard.order);
            } else {
              notes = pageNotesBlocks.filter(q => q.order > card.order);
            }

            notes.forEach((note, i) => {
              pageNotes[note.id] = { ...note, cardId: card.id, order: i };
            });
          });
          //
          // update page
          // Move section page info to page
          const pageUpdate = {
            id: page.id,
            title: childPage.text,
            authorAnswer: childPage.authorAnswer || { answer: null, confidence: null },
            section: s.id,
            description: childPage.description || '',
            noteCards,
            pageNotes,
            order: pageIndex
          };
          console.log(pageUpdate);
          //fb.pagesCollection.doc(page.id).update(pageUpdate);
          dispatch('pages/patch', pageUpdate, { root: true });
        });
      });

      //  update context sections
      const contextUpdate = {
        id: contextId,
        sections,
        description: pages[contextId].description || ''
      };
      console.log(contextUpdate);
      dispatch('patch', contextUpdate);
      //fb.contextsCollection.doc(contextId).update(contextUpdate);
    },
    subscribeToContext({ dispatch, commit }, { id }) {
      if (id == undefined) {
        throw 'no id was provided for the context to which you want to subscribe';
      }

      dispatch('openDBChannel', { where: [['id', '==', id]] });
      commit('setSubscribedId', id);
    },
    unsubscribeToContext({ dispatch }) {
      console.log('unsubscribe');
      dispatch('closeDBChannel', { clearModule: true });
    },
    async createNewContext(
      { dispatch, rootState, getters, rootGetters },
      { parentFolderId, workspaceId, text }
    ) {
      console.log('creating new context');
      //get necessary items throw an error if not provided
      let saveFolder = parentFolderId;
      let localText = text;
      if (workspaceId == undefined) {
        throw 'no workspaceId was provided for the folder parent update review your function inputs and try again';
      }
      //get userId and throw an error if there are any problems getting the user ID
      if (!rootGetters['auth/isUser']) {
        return 'auth/isUser is set to false';
      }
      const userId = rootGetters['auth/userId'];
      //add members to user profile
      const userProfile = rootGetters['auth/profile'];
      userProfile.id = userId;

      if (localText == undefined) {
        localText = 'Untitled Context';
      }
      //setup context permissions
      let contextPermissions = undefined;
      if (saveFolder == undefined || saveFolder == null) {
        console.log('save folder is undefined saving it to workspaceId');
        saveFolder = workspaceId;
        contextPermissions = {
          editing: [workspaceId],
          viewing: [],
          commenting: [],
          voting: []
        };
      } else {
        console.log('save folder is defined saving it to save folder');
        console.log('workspaceId', workspaceId);
        const workspace = rootState.workspaces.workspacesData[workspaceId];
        const folderOfInterest = workspace.folders[saveFolder];
        contextPermissions = { ...folderOfInterest.permissions };
      }
      console.log('saveFolder', saveFolder);

      // const sectionId = getters['dbRef'].doc().id;
      contextPermissions.publicVote = true;
      contextPermissions.owner = userId;
      contextPermissions.visibility = 'private';
      contextPermissions.voterURL = '';
      contextPermissions.viewURL = '';
      contextPermissions.commenting = [];
      contextPermissions.voting = [];
      // const sections = {};
      // sections[sectionId] = {
      //   id: sectionId,
      //   description: '',
      //   order: 0,
      //   text: 'Ideas'
      // };
      //create the new context object
      const contextId = getters['dbRef'].doc().id;

      const pageId = await dispatch(
        'pages/addPage',
        { contextId, template: false, order: 0, title: localText, noWait: true },
        { root: true }
      );

      console.log(pageId);
      const newContextData = {
        authors: {},
        createdBy: userId,
        createdOn: new Date(),
        draft: true,
        new: true,
        text: localText,
        description: '',
        id: contextId,
        workspace: workspaceId,
        permissions: contextPermissions,
        basePage: pageId
      };
      newContextData.authors[userId] = userProfile;

      //update vuex
      const workspaceLiteData = {
        id: newContextData.id,
        text: newContextData.text,
        userPermission: 'editing',
        authors: newContextData.authors,
        createdOn: newContextData.createdOn,
        createdBy: newContextData.createdBy,
        workspace: newContextData.workspace,
        type: 'context'
      };
      dispatch(
        'userWorkspaceLite/addNewContextToLiteVuexOnly',
        { doc: workspaceLiteData },
        { root: true }
      );

      console.log('newContextData', newContextData);
      //create a new context
      await dispatch('insert', newContextData);

      // dispatch('pages/createNewPage', { pageId: contextId, contextId: contextId }, { root: true });

      // dispatch('addQuestion', {
      //   text: 'Concerns & Considerations',
      //   order: 0,
      //   type: 1,
      //   contextId
      // });

      //  Add context to folder
      dispatch(
        'workspaces/addContextToFolder',
        { workspaceId, folderId: saveFolder, contextId },
        { root: true }
      );

      //return the Id
      return contextId;
    },
    deleteContext({ dispatch }, { contextId }) {
      if (contextId == undefined) {
        throw 'no contextId was provided for context you wish to delete review your function inputs and try again';
      }
      //remove from vuex before anything else
      dispatch(
        'userWorkspaceLite/removeDocWorkspaceLiteVuexOnly',
        { docId: contextId },
        { root: true }
      );
      //delete the context
      fb.contextsCollection
        .doc(contextId)
        .delete()
        .then(() => console.log(`context ${contextId} deleted`));
    },
    async addSection({ state, dispatch, getters }, { contextId, order, text = '' }) {
      const context = state.contextData[contextId];
      const id = getters['dbRef'].doc().id;
      const section = {
        id,
        order: order != undefined ? order : context ? Object.keys(context.sections).length : 0,
        text,
        description: ''
      };
      const update = {};
      update[id] = section;
      try {
        await dispatch('patch', { id: contextId, sections: update });
        return id;
      } catch (e) {
        throw new Error(e);
      }
    },
    removeSection({ state, dispatch, getters }, { contextId, sectionId }) {
      const id = contextId ? contextId : getters.context.id;
      const context = state.contextData[id];

      const update = {};
      update[sectionId] = { toDelete: true };
      const sections = Object.values(context.sections).filter(s => !s.toDelete);
      sections.forEach(section => {
        if (section.order > context.sections[sectionId].order) {
          update[section.id] = {
            order: increment(-1)
          };
        }
      });
      dispatch('patch', { id, sections: update, needsCleanup: true });
    },
    updateSectionText({ dispatch }, { contextId, sectionId, text }) {
      const update = {};
      update[sectionId] = { text };
      dispatch('patch', { id: contextId, sections: update });
    },
    updateSectionDescription({ dispatch }, { contextId, sectionId, description }) {
      const update = {};
      update[sectionId] = { description };
      dispatch('patch', { id: contextId, sections: update });
    },
    moveSection({ dispatch, state, getters }, { contextId, sectionId, toOrder }) {
      const id = contextId ? contextId : getters.context.id;
      const context = state.contextData[id];
      const section = context.sections[sectionId];
      const update = {};
      update[sectionId] = { order: toOrder };
      Object.values(context.sections).forEach(s => {
        if (section.order > toOrder) {
          // moving back
          if (s.order >= toOrder && s.order < section.order) {
            update[s.id] = { order: increment(1) };
          }
        } else {
          // moving forward
          if (s.order <= toOrder && s.order > section.order) {
            update[s.id] = { order: increment(-1) };
          }
        }
      });

      dispatch('patch', { id, sections: update });
    },
    checkContextAccessPersmissions({ rootState }, contextId) {
      console.log('checking context access permissions');
      ////////////////// functions ////////////////
      return new Promise(async (resolve, reject) => {
        //function to check if it's public
        const isPublic = async function(contextId) {
          //  next check if the context is public
          const publicMatch = await fb.contextsCollection
            .where(fb.firestore.FieldPath.documentId(), '==', contextId)
            .where('permissions.visibility', '==', 'public')
            .get();

          return !publicMatch.empty;
        };

        const userHasAccess = async (contextId, userId) => {
          const workspaceLiteMatch = await fb.userWorkspaceLiteCollection
            .where(`userId`, '==', userId)
            .where(`documentData.${contextId}.id`, '==', contextId)
            .get();

          return !workspaceLiteMatch.empty;
        };

        ////////////////// check auth state ////////////////
        let localAuth = await firebase.auth();
        ////////////////// if no auth state then check if public - resolve if so reject if not ////////////////
        console.log('localAuth', localAuth);
        if (!localAuth.currentUser) {
          const publicContext = await isPublic(contextId);
          if (publicContext) {
            resolve('public');
            return;
          } else {
            console.log('no user and not public');
            reject('no user and not public');
            return;
          }
          //if there is a user then try and wait until contextsLite is loaded
        } else {
          const userId = localAuth.currentUser.uid;
          try {
            const allUserDocuments = rootState.userWorkspaceLite.allUserDocuments;
            //if userContextLite is not loaded then check the db
            if (allUserDocuments === undefined || Object.keys(allUserDocuments).length === 0) {
              console.log('no userDocuments loaded, use the db method');
              const dbQuery = await Promise.all([
                isPublic(contextId),
                userHasAccess(contextId, userId)
              ]);
              console.log('dbQuery', dbQuery);
              if (dbQuery.includes(true)) {
                resolve('access');
              } else {
                reject('no access');
              }
              //if it is loaded then just check vuex store.
            } else {
              //if allUserDocuments is loaded from WorkspaceLite check for contextId resolve if exists, if it doesn't check public
              if (contextId in allUserDocuments) {
                resolve('contextsLite');
                return;
              } else {
                const publicContext = await isPublic(contextId);
                if (publicContext) {
                  resolve('public');
                  return;
                } else {
                  console.log('user is logged in but no access and not public');
                  reject('user is logged in but no access and not public');
                  return;
                }
              }
            }
          } catch (e) {
            reject(e);
          }
        }
      });
    },
    updateContextPermissionsField({ dispatch }, { contextId, fieldKey, fieldValue }) {
      //get necessary items throw an error if not provided
      if (contextId == undefined) {
        throw 'no contextId was provided for the context permissions update, review your function inputs and try again';
      }
      const possibleKeyValues = [
        'visibility',
        'publicVote',
        'owner',
        'editing',
        'commenting',
        'voting',
        'viewing',
        'voterURL',
        'viewURL'
      ];
      if (!possibleKeyValues.includes(fieldKey)) {
        throw `input fieldKey can only be one of the following values: ${possibleKeyValues.toString()}; please check your input "fieldKey" and try again`;
      }
      if (fieldValue == undefined) {
        throw `input field value was not provided, please check your inputs and try again`;
      }
      const arrayFields = ['editing', 'commenting', 'voting', 'viewing'];
      if (arrayFields.includes(fieldKey) && fieldValue.constructor !== Array) {
        throw `if input fieldKey is equal to ${fieldKey}, then input fieldValue must be an array,  please check that fieldValue is an array and try again`;
      }
      //create the update object
      const contextUpdate = {
        id: contextId,
        permissions: {}
      };
      contextUpdate.permissions[fieldKey] = fieldValue;
      console.log('contextPermissionsUpdate', contextUpdate);
      dispatch('patch', contextUpdate);
    },
    updateContextText({ dispatch, state }, { text, contextId = state.subscribedId }) {
      //return error if proper fields weren't provided
      if (text == undefined) {
        throw 'no text field was provided for the updating the context';
      }

      //update vuex and database with vuex-easy-firestore
      dispatch('patch', { id: contextId, text });
      dispatch('context/addToAuthorIfNecessary', {}, { root: true });
    },
    updateContextDescription({ dispatch, state }, { text, contextId = state.subscribedId }) {
      //return error if proper fields weren't provided
      if (text == undefined) {
        throw 'no text field was provided for the updating the context';
      }

      //update vuex and database with vuex-easy-firestore
      dispatch('patch', { id: contextId, description: text });
      dispatch('context/addToAuthorIfNecessary', {}, { root: true });
    },
    updateContextStates({ dispatch, state }, { states, contextId = state.subscribedId }) {
      //return error if proper fields weren't provided
      if (states == undefined) {
        throw 'no states field was provided for the updating the context';
      }

      //update vuex and database with vuex-easy-firestore
      dispatch('patch', { id: contextId, states });
    },
    async addQuestion(
      { dispatch, getters, state },
      {
        text,
        order,
        type,
        sort = true,
        contextId = state.subscribedId,
        template,
        batchSync = true,
        trackEvent = true
      }
    ) {
      //get necessary items throw an error if not provided
      if (text == undefined) {
        throw 'no text field was provided for the new question';
      }
      if (isNaN(order)) {
        throw 'no order was provided for the new question or the provided order is not a number';
      }
      if (isNaN(type)) {
        throw 'no type was provided for the new question or the provided type is not a number';
      }

      //get necessary Id's
      const id = getters['dbRef'].doc().id;

      //create the update object for the addition of the question
      const questionUpdate = {};
      questionUpdate[id] = {
        id,
        order,
        type,
        text,
        authorAnswer: { answer: null, confidence: null }
      };

      //update all the other questions that have a greater order than the one being added
      if (sort) {
        let questions = [];
        if (contextId == state.subscribedId) {
          questions = getters.questions;
        } else {
          //  fetch the contextId and update the quesitons with that
          try {
            const contextData = await fb.contextsCollection.doc('contextId').get();
            questions = contextData.exists ? Object.values(contextData.data().questions) : [];
          } catch (e) {
            console.error(e);
          }
        }
        questions.forEach(question => {
          if (question.order >= order) {
            questionUpdate[question.id] = {
              order: increment(1)
            };
          }
        });
      }

      console.log(questionUpdate);
      //update vuex and database with vuex-easy-firestore
      dispatch('patch', { id: contextId, questions: questionUpdate });
      dispatch(
        'pages/createNewPage',
        { pageId: id, contextId: contextId, template },
        { root: true }
      );
      dispatch('context/addToAuthorIfNecessary', {}, { root: true });

      if (trackEvent) {
        dispatch('track/trackEvent', { action: 'Create new question' }, { root: true });
      }
      if (batchSync) {
        dispatch('batchSync');
      }

      return id;
    },
    removeQuestion({ state, dispatch, getters }, { id }) {
      //get necessary Id's return error if not provided
      const contextId = state.subscribedId;
      if (!id) {
        throw 'no id was provided for the question you want to remove';
      }

      //find it's order and update all the ones with order greater than it
      const { questions } = getters;
      const currentQuestion = questions.find(e => e.id === id);
      const { order } = currentQuestion;
      const questionUpdate = {};
      questions.forEach(question => {
        if (question.order > order) {
          questionUpdate[question.id] = {
            order: increment(-1)
          };
        }
      });
      questionUpdate[id] = {};
      questionUpdate[id].toDelete = true;

      // dispatch('track/trackEvent', { action: 'Delete question' }, { root: true });
      dispatch('pages/removePage', { pageId: id }, { root: true });
      dispatch('context/addToAuthorIfNecessary', {}, { root: true });
      //update the orders if the object length is not 0
      if (Object.keys(questionUpdate).length !== 0) {
        console.log('patching the update delete');
        dispatch('patch', { id: contextId, questionsToDelete: true, questions: questionUpdate });
      } else {
        console.log('no order needed updated');
      }
      dispatch('batchSync');
    },
    updateQuestionText({ dispatch, state }, { id, text }) {
      //get necessary Id's
      const contextId = state.subscribedId;
      if (!text) {
        throw 'no text field was provided for the updated question text';
      }
      if (!id) {
        throw 'no id was provided for the question you want to update';
      }

      //create the update object
      const questionUpdate = {};
      questionUpdate[id] = {
        text
      };

      //update vuex and database with vuex-easy-firestore
      dispatch('patch', { id: contextId, questions: questionUpdate });
      dispatch('context/addToAuthorIfNecessary', {}, { root: true });
    },
    updateQuestionDescription({ dispatch, state }, { id, text }) {
      //get necessary Id's
      const contextId = state.subscribedId;
      if (!text) {
        throw 'no text field was provided for the updated question text';
      }
      if (!id) {
        throw 'no id was provided for the question you want to update';
      }

      //create the update object
      const questionUpdate = {};
      questionUpdate[id] = {
        description: text
      };

      //update vuex and database with vuex-easy-firestore
      dispatch('patch', { id: contextId, questions: questionUpdate });
      dispatch('context/addToAuthorIfNecessary', {}, { root: true });
    },
    updateQuestionType({ dispatch, state }, { id, type }) {
      //get necessary Id's
      const contextId = state.subscribedId;
      if (isNaN(type)) {
        throw 'type was either not provided or is not a number';
      }
      if (!id) {
        throw 'no id was provided for the question you want to update';
      }

      //create the update object
      const questionUpdate = {};
      questionUpdate[id] = {
        type
      };

      //update vuex and database with vuex-easy-firestore
      dispatch('patch', { id: contextId, questions: questionUpdate });
      dispatch('context/addToAuthorIfNecessary', {}, { root: true });
    },
    updateQuestionAuthorAnswer({ dispatch, state }, { id, answer, confidence }) {
      const contextId = state.subscribedId;
      if (answer == undefined && confidence == undefined) {
        throw 'input answer and confidence was either not provided or is undefined';
      }

      //create the update object
      const questionUpdate = {};
      questionUpdate[id] = {
        authorAnswer: {
          answer,
          confidence
        }
      };

      //update vuex and database with vuex-easy-firestore
      dispatch('patch', { id: contextId, questions: questionUpdate });
      dispatch('context/addToAuthorIfNecessary', {}, { root: true });
      dispatch('track/trackEvent', { action: 'Add question answer' }, { root: true });
    },
    moveQuestionsByOrder({ dispatch, getters, state }, { ordersToMove, moveLocation }) {
      const contextId = state.subscribedId;
      if (ordersToMove.constructor !== Array) {
        throw 'input ordersToMove was either not provided or is not an array please check your function inputs and try again';
      }
      if (isNaN(moveLocation)) {
        throw 'moveLocation was either not provided or is not a number please check your function inputs and try again';
      }
      if (!isSequetial(ordersToMove)) {
        throw 'input ordersToMove is not a sequential set of integers please check your function inputs and try again';
      }

      //get the update from our helper function
      let questionsUpdate;
      questionsUpdate = helpers.moveHelper(ordersToMove, moveLocation, getters.questions);
      console.log('questionsUpdate', questionsUpdate);
      //send the update
      if (Object.keys(questionsUpdate).length !== 0) {
        dispatch('patch', { id: contextId, questions: questionsUpdate });
        dispatch('context/addToAuthorIfNecessary', {}, { root: true });
      } else {
        throw 'problems generating the update object please check that the moveLocation input value is not included in the ordersToMove Input Array';
      }
    },
    moveQuestionsById({ dispatch, getters }, { idsToMove, moveLocation }) {
      if (idsToMove.constructor !== Array) {
        throw 'input idsToMove was either not provided or is not an array please check your function inputs and try again';
      }
      if (isNaN(moveLocation)) {
        throw 'moveLocation was either not provided or is not a number please check your function inputs and try again';
      }

      //get the orders of the provided id's from our helper function
      const { questions } = getters;
      const ordersToMove = [];
      questions.forEach(question => {
        if (idsToMove.includes(question.id)) {
          ordersToMove.push(question.order);
        }
      });

      //order them using the move by order function
      console.log('orders to move', ordersToMove);
      console.log('moveLocation', moveLocation);
      dispatch('moveQuestionsByOrder', { ordersToMove, moveLocation });
    },
    addToAuthorIfNecessary({ rootGetters, getters, dispatch }, { userIds }) {
      //  You can pass in an array of Ids, or nothing and it will update with current user
      const { context } = getters;
      if (context && context.authors) {
        let usersToAdd;
        if (userIds == undefined) {
          //  No userId passed in, get current user
          usersToAdd = [rootGetters['auth/userId']];
        } else {
          usersToAdd = userIds;
        }
        //  filter the users just to ones who need to be added
        usersToAdd = usersToAdd.filter(u => !Object.keys(context.authors).includes(u));
        if (usersToAdd.length > 0) {
          const newAuthors = { ...context.authors };
          let updated = false;
          //  hydrate with profiles and add to new object
          usersToAdd.forEach(u => {
            try {
              const profile = rootGetters['workspaces/currentWorkspace'].members[u];
              newAuthors[u] = {
                avatar: profile.avatar,
                name: profile.name,
                id: u
              };
              updated = true;
              console.log(`new Authors with new author ${profile.name} - ${u}`, newAuthors);
            } catch (e) {
              console.log(`error adding user ${u} to new author object`, e);
            }
          });
          if (updated) {
            //  if we actually updated the newAuthor object, save it
            dispatch('patch', { id: context.id, authors: newAuthors });
          }
        }
      } else {
        console.log('no need to update authors');
      }
    }
  }
};

export default contextModule;
